export const SELECTE_FEATURE = 'SELECTE_FEATURE';
export const UNSELECTE_FEATURE = 'UNSELECTE_FEATURE';

export const selectFeature = (feature, layer_feature_id, backSection = 'direction') => {
  return {
    type: SELECTE_FEATURE,
    feature,
    layer_feature_id,
    backSection
  };
};

export const unselectFeature = () => {
  return {
    type: UNSELECTE_FEATURE,
  };
};
